


















import { Component, Vue } from 'vue-property-decorator';
import { GlobalEventBus, GlobalEvents, SnackBarEventArgs } from '@/utils/events';

@Component
export default class MpGlobalSnackbar extends Vue {
  snackBarEventArgs: SnackBarEventArgs = new SnackBarEventArgs();
  showSnackBar: boolean = false;

  async created() {
    GlobalEventBus.$on(GlobalEvents.SnackBar, this.snackBarHandler);
  }

  beforeDestroy() {
    GlobalEventBus.$off(GlobalEvents.SnackBar);
  }

  snackBarHandler(args: SnackBarEventArgs) {
    this.snackBarEventArgs = args;
    this.showSnackBar = true;
  }
}
